import React from "react";
import styles from './Table.styl';

export default Table;

function Table(props) {

	let tablestyle = ''
	let tableSelstyle = ''
	let bgColor = props.color ? props.color : '#ffc93a'

	switch (props.configType && props.configType) {
		case ('bap'):
			tablestyle = (props.type === 'Bucket' ? {
				display: "grid",
				gridTemplateColumns: '29% 50% 15% 6%',
				cursor: 'pointer'
			} : {display: "grid", gridTemplateColumns: '29% 64% 7%', cursor: 'pointer'})
			return (<div className={styles.wrapper} style={props.styles}>
					<div className={styles.table_head + ' ' + styles.table_name}
							 style={{backgroundColor: bgColor}}>{props.title}</div>
					<div className={styles.table_head} style={{backgroundColor: bgColor}}>
						<div style={tablestyle}>
							<div className={styles.sell} style={{border: "1px solid " + bgColor}}>Артикул</div>
							<div className={styles.sell} style={{border: "1px solid " + bgColor}}>Наименование</div>
							{props.type === 'Bucket'
								? <React.Fragment>
									<div className={styles.sell} style={{border: "1px solid " + bgColor}}>Кол-во</div>
									<div className={styles.sell}/>
								</React.Fragment>
								: <div className={styles.sell}/>}
						</div>
					</div>
					<div className={styles.itemList}>
						{props.type === 'BapList' && (props.itemsEmb.length > 0) ?
							<React.Fragment>
								{props.itemsEmb.length > 0 &&
									<React.Fragment>
										<div className={styles.table_head + ' ' + styles.table_head_name}
												 style={{backgroundColor: bgColor}}>Доступны совместимые с бап встраиваемые светильники по
											запросу
										</div>
										{props.itemsEmb.map((item, index) =>
											<TableRow
												key={index + Date.now()}
												item={item}
												type={props.type}
												addInfo={props.addInfo}
												onDelete={props.onDelete}
												addBasket={props.addBasket}
												onChangeQuantity={props.onChangeQuantity}
												onSelect={props.onSelect}
												tablestyle={tablestyle}
												itemInfo={props.itemInfo}
												onMouseEnter={props.onMouseEnter}
												onMouseLeave={props.onMouseLeave}
												BapListHover={props.BapListHover}
												color={props.color}
											/>)}
									</React.Fragment>
								}
							</React.Fragment>
							: props.items.map((item, index) =>
								<TableRow
									key={index + Date.now()}
									item={item}
									type={props.type}
									addInfo={props.addInfo}
									onDelete={props.onDelete}
									addBasket={props.addBasket}
									onChangeQuantity={props.onChangeQuantity}
									onSelect={props.onSelect}
									tablestyle={tablestyle}
									itemInfo={props.itemInfo}
									onMouseEnter={props.onMouseEnter}
									onMouseLeave={props.onMouseLeave}
									BapListHover={props.BapListHover}
									color={props.color}

								/>)}
					</div>
				</div>
			);
		case ('hatch'):
			tableSelstyle = (props.type === 'Bucket' ? {
				display: "grid",
				gridTemplateColumns: '22% 28% 16% 16% 11% 7%'
			} : {display: "grid", gridTemplateColumns: '29% 64% 7%'})
			tablestyle = (props.type === 'Bucket' ? {
				display: "grid",
				gridTemplateColumns: '24% 25% 15% 15% 11% 10%'
			} : {display: "grid", gridTemplateColumns: '29% 64% 7%'})
			return (<div className={styles.wrapper} style={props.styles}>
					<div className={styles.table_head + ' ' + styles.table_name}
							 style={{backgroundColor: bgColor}}>{props.title}</div>
					<div className={styles.table_head} style={{backgroundColor: bgColor}}>
						<div style={tablestyle}>
							<div className={styles.sell} style={{border: "1px solid " + bgColor}}>Артикул</div>
							<div className={styles.sell}>Наименование</div>
							{props.type === 'Bucket'
								? <React.Fragment>
									<div className={styles.sell} style={{border: "1px solid " + bgColor}}>Цена</div>
									<div className={styles.sell} style={{border: "1px solid " + bgColor}}>Сумма</div>
									<div className={styles.sell} style={{border: "1px solid " + bgColor}}>Кол-во</div>
									<div className={styles.sell} style={{border: "1px solid " + bgColor}}/>
								</React.Fragment>
								: <div className={styles.sell} style={{border: "1px solid " + bgColor}}/>}
						</div>
					</div>
					<div className={styles.itemList}>
						{props.items.map((item, index) =>
							<TableRow
								key={index + Date.now()}
								item={item}
								type={props.type}
								addInfo={props.addInfo}
								onDelete={props.onDelete}
								addBasket={props.addBasket}
								onChangeQuantity={props.onChangeQuantity}
								onSelect={props.onSelect}
								tablestyle={tableSelstyle}
								itemInfo={props.itemInfo}
								onMouseEnter={props.onMouseEnter}
								onMouseLeave={props.onMouseLeave}
								configType={props.configType}
								color={bgColor}
							/>)}
					</div>
					<div className={styles.table_total} style={{backgroundColor: bgColor}}><span>Итого</span>
						<span>{props.totalPrice} руб</span></div>

				</div>
			);
		case ('hatchSep'):
			tableSelstyle = ({display: "grid", gridTemplateColumns: '22% 28% 16% 16% 11% 7%'})
			tablestyle = ({display: "grid", gridTemplateColumns: '24% 25% 15% 15% 11% 10%'})
			return (<div className={styles.wrapper} style={props.styles}>
					<div className={styles.table_head + ' ' + styles.table_name}
							 style={{backgroundColor: bgColor}}>{props.title}</div>
					<div className={styles.table_head} style={{backgroundColor: bgColor}}>
						<div style={tablestyle}>
							<div className={styles.sell} style={{border: "1px solid " + bgColor}}>Артикул</div>
							<div className={styles.sell}>Наименование</div>
							<div className={styles.sell} style={{border: "1px solid " + bgColor}}>Цена</div>
							<div className={styles.sell} style={{border: "1px solid " + bgColor}}>Сумма</div>
							<div className={styles.sell} style={{border: "1px solid " + bgColor}}>Кол-во</div>
							<div className={styles.sell} style={{border: "1px solid " + bgColor}}/>
						</div>
					</div>
					<div className={styles.itemList}>
						{props.items.map((item, index) =>
							<TableSortRow
								key={index + Date.now()}
								item={item}
								type={props.type}
								addInfo={props.addInfo}
								onDelete={props.onDelete}
								addBasket={props.addBasket}
								onChangeQuantity={props.onChangeQuantity}
								onSelect={props.onSelect}
								tablestyle={tableSelstyle}
								nameSolution={props.nameSolution}
								itemInfo={props.itemInfo}
								onMouseEnter={props.onMouseEnter}
								onMouseLeave={props.onMouseLeave}
								configType={props.configType}
								color={bgColor}
							/>)}
					</div>
					<div className={styles.table_total} style={{backgroundColor: bgColor}}><span>Итого</span>
						<span>{props.totalPrice} руб</span></div>

				</div>
			);
		case 'lan':
		case 'optic':
		case 'power':
		case 'ibp':
			tablestyle = (props.type === 'Bucket'
				? {
					display: "grid",
					gridTemplateColumns: '24% 25% 15% 15% 11% 10%'
				} : {display: "grid", gridTemplateColumns: '29% 64% 7%'})
			tableSelstyle = (props.type === 'Bucket'
				? {
					display: "grid", gridTemplateColumns: '22% 28% 16% 16% 11% 7%', cursor: 'pointer'
				} : {display: "grid", gridTemplateColumns: '29% 64% 7%', cursor: 'pointer'})

			return (
				<TableWithPrice
					type={props.type}
					addInfo={props.addInfo}
					onDelete={props.onDelete}
					addBasket={props.addBasket}
					onChangeQuantity={props.onChangeQuantity}
					onSelect={props.onSelect}
					tablestyle={tablestyle}
					itemInfo={props.itemInfo}
					bgColor={bgColor}
					configType={props.configType}
					tableSelstyle={tableSelstyle}
					items={props.items}
					id={props.id}
					styles={props.styles}
					title={props.title}
				/>)
		case 'pipe':
			tableSelstyle = (props.type === 'Bucket' ? {
				display: "grid",
				gridTemplateColumns: '22% 28% 16% 16% 11% 7%'
			} : props.type === 'Cable' ? {
				display: "grid",
				gridTemplateColumns: '44% 29% 20% 7%',
			} : {
				display: "grid",
				gridTemplateColumns: '29% 44% 20% 7%'
			})
			tablestyle = (props.type === 'Bucket' ? {
				display: "grid",
				gridTemplateColumns: '24% 25% 15% 15% 11% 10%'
			} : props.type === 'Cable' ? {display: "grid", gridTemplateColumns: '44% 29% 20% 7%'} : {
				display: "grid",
				gridTemplateColumns: '29% 44% 20% 7%'
			})
			return (<div className={styles.wrapper} style={props.styles}>
					<div className={styles.table_head + ' ' + styles.table_name}
							 style={{backgroundColor: bgColor}}>{props.title}</div>
					<div className={styles.table_head} style={{backgroundColor: bgColor}}>
						<div style={tablestyle}>
							{props.type === 'Cable' ? <React.Fragment>
								<div className={styles.sell}>Наименование</div>
								<div className={styles.sell} style={{border: "1px solid " + bgColor}}>Сечение</div>
								<div className={styles.sell} style={{border: "1px solid " + bgColor}}>Количество</div>
							</React.Fragment> : props.type === 'Bucket'
								? <React.Fragment>
									<div className={styles.sell} style={{border: "1px solid " + bgColor}}>Артикул</div>
									<div className={styles.sell} style={{border: "1px solid " + bgColor}}>Наименование</div>
								</React.Fragment> : <React.Fragment>
									<div className={styles.sell} style={{border: "1px solid " + bgColor}}>Артикул</div>
									<div className={styles.sell} style={{border: "1px solid " + bgColor}}>Номенклатура</div>
									<div className={styles.sell}>Заполнение</div>
								</React.Fragment>
							}
							{props.type === 'Bucket'
								? <React.Fragment>
									<div className={styles.sell} style={{border: "1px solid " + bgColor}}>Цена</div>
									<div className={styles.sell} style={{border: "1px solid " + bgColor}}>Сумма</div>
									<div className={styles.sell} style={{border: "1px solid " + bgColor}}>Кол-во</div>
									<div className={styles.sell} style={{border: "1px solid " + bgColor}}/>
								</React.Fragment>
								: <div className={styles.sell} style={{border: "1px solid " + bgColor}}/>}
						</div>
					</div>
					<div className={styles.itemList}>
						{props.items.map((item, index) => <div>
							<TableRow
								key={index + Date.now()}
								item={item}
								type={props.type}
								addInfo={props.addInfo}
								onDelete={props.onDelete}
								addBasket={props.addBasket}
								onChangeQuantity={props.onChangeQuantity}
								onSelectCable={props.onSelectCable}
								onSelect={props.onSelect}
								tablestyle={tableSelstyle}
								itemInfo={props.itemInfo}
								onMouseEnter={props.onMouseEnter}
								onMouseLeave={props.onMouseLeave}
								configType={props.configType}
								color={bgColor}
							/>
							{props.type === 'Bucket' && item.cableList.map((i, id) =>
								<TableRowPipeCable key={id + Date.now()}
																	 item={i}
																	 color={bgColor}/>)}
						</div>)}
					</div>
					{props.type === 'Bucket' &&
						<div className={styles.table_total} style={{backgroundColor: bgColor}}><span>Итого</span>
							<span>{props.totalPrice} руб</span></div>
					}
				</div>
			);
		case 'ground_select':
			tablestyle = (props.type === 'Bucket' ? {
				display: "grid",
				gridTemplateColumns: '29% 50% 15% 6%',
				cursor: 'pointer'
			} : {display: "grid", gridTemplateColumns: '29% 64% 7%', cursor: 'pointer'})

			return (<div className={styles.wrapper} style={props.styles}>
					<div className={styles.table_head + ' ' + styles.table_name}
							 style={{backgroundColor: bgColor}}>{props.title}</div>
					<div className={styles.table_head} style={{backgroundColor: bgColor}}>
						<div style={tablestyle}>
							<div className={styles.sell} style={{border: "1px solid " + bgColor}}>Артикул</div>
							<div className={styles.sell}>Наименование</div>
							{props.type === 'Bucket'
								? <React.Fragment>
									<div className={styles.sell} style={{border: "1px solid " + bgColor}}>Кол-во</div>
									<div className={styles.sell} style={{border: "1px solid " + bgColor}}/>
								</React.Fragment>
								: <div className={styles.sell} style={{border: "1px solid " + bgColor}}/>}
						</div>
					</div>
					<div className={styles.itemList}>
						{props.items.map((item, index) =>
							<TableRow
								key={index + Date.now()}
								item={item}
								type={props.type}
								addInfo={props.addInfo}
								onDelete={props.onDelete}
								addBasket={props.addBasket}
								onChangeQuantity={props.onChangeQuantity}
								onSelect={props.onSelect}
								tablestyle={tablestyle}
								itemInfo={props.itemInfo}
								onMouseEnter={props.onMouseEnter}
								onMouseLeave={props.onMouseLeave}
								configType={props.configType}
								color={bgColor}
							/>)}
					</div>
				</div>
			);
		case 'bapLabel':
			tablestyle = (props.type === 'Bucket'||props.type ==='List' ? {
				display: "grid",
				gridTemplateColumns: '29% 50% 15% 6%',
				cursor: 'pointer'
			} : {display: "grid", gridTemplateColumns: '29% 64% 7%', cursor: 'pointer'})


			return (<div className={styles.wrapper} style={props.styles}>
					<div className={styles.table_head + ' ' + styles.table_name}
							 style={{backgroundColor: bgColor}}>{props.title}</div>
					<div className={styles.table_head} style={{backgroundColor: bgColor}}>
						<div style={tablestyle}>
							<div className={styles.sell} style={{border: "1px solid " + bgColor}}>Артикул</div>
							<div className={styles.sell}>Наименование</div>
							{props.type === 'Bucket'
								? <React.Fragment>
									<div className={styles.sell} style={{border: "1px solid " + bgColor}}>Кол-во</div>
									<div className={styles.sell} style={{border: "1px solid " + bgColor}}/>
								</React.Fragment>
								: props.type === 'List'?
									<React.Fragment>
									<div className={styles.sell}>{props.subTitle}</div>
									<div className={styles.sell}/>
									</React.Fragment>
									: <div className={styles.sell} style={{border: "1px solid " + bgColor}}/>
							}
						</div>
					</div>
					<div className={styles.itemList}>
						{props.items.map((item, index) =>
							<TableRow
								key={index + Date.now()}
								item={item}
								type={props.type}
								addInfo={props.addInfo}
								onDelete={props.onDelete}
								addBasket={props.addBasket}
								onChangeQuantity={props.onChangeQuantity}
								onSelect={props.onSelect}
								tablestyle={props.type ==='List'?{display: "grid", gridTemplateColumns: '29% 64% 7%', cursor: 'pointer'}:tablestyle}
								itemInfo={props.itemInfo}
								onMouseEnter={props.onMouseEnter}
								onMouseLeave={props.onMouseLeave}
								configType={props.configType?props.configType:null}
								color={bgColor}
							/>)}
					</div>
				</div>
			);
		case ('enclosure_titan'):
			tableSelstyle = (props.type === 'Bucket' ? {
				display: "grid",
				gridTemplateColumns: '22% 28% 16% 16% 11% 7%',
			}:{
				display: "grid",
						gridTemplateColumns: '29% 64% 7%'})
			tablestyle = (props.type === 'Bucket' ? {
				display: "grid",
				gridTemplateColumns: '24% 25% 15% 15% 11% 10%',
			} : {display: "grid", gridTemplateColumns: '29% 64% 7%'})
			return (<div className={styles.wrapper} style={props.styles}>
					<div className={styles.table_head + ' ' + styles.table_name}
							 style={{backgroundColor: bgColor}}>{props.title}</div>
					<div className={styles.table_head} style={{backgroundColor: bgColor}}>
						<div style={tablestyle}>
							<div className={styles.sell} style={{border: "1px solid " + bgColor}}>Артикул</div>
							<div className={styles.sell}>Наименование</div>
							{props.type === 'Bucket'
								? <React.Fragment>
									<div className={styles.sell} style={{border: "1px solid " + bgColor}}>Цена</div>
									<div className={styles.sell} style={{border: "1px solid " + bgColor}}>Сумма</div>
									<div className={styles.sell} style={{border: "1px solid " + bgColor}}>Кол-во</div>
									<div className={styles.sell} style={{border: "1px solid " + bgColor}}/>
								</React.Fragment>
								: <div className={styles.sell} style={{border: "1px solid " + bgColor}}/>}
						</div>
					</div>
					<div className={styles.itemList}>
						{props.items.map((item, index) =>
							<div key={index+'table'}>
								{props.type === 'Bucket'&&
									<div  style={{height:'15px', backgroundColor:'#ffc93a', textAlign:'center'}}> Конфигурация №{index+1}</div>}

							<TableRow
								key={index + item.article}
								item={item}
								type={props.type}
								addInfo={props.addInfo}
								onDelete={props.onDelete}
								addBasket={props.addBasket}
								onChangeQuantity={props.onChangeQuantity}
								onSelect={props.onSelect}
								tablestyle={tableSelstyle}
								itemInfo={props.itemInfo}
								onMouseEnter={props.onMouseEnter}
								onMouseLeave={props.onMouseLeave}
								configType={props.configType}
								color={bgColor}
								activeArticle={props.activeArticle}
							/>
								{props.type === 'Bucket'&&
								<div style={{height:'2px', backgroundColor:'#ffc93a'}}></div>}
						{props.type === 'Bucket' && item.list.map((i, id) =>
							<TableRowAccessoryTitan key={id + Date.now()+'list'}
																			item={i}
																			type={props.type}
																			addInfo={props.addInfo}
																			onDelete={props.onDelete}
																			addBasket={props.addBasket}
																			onChangeQuantity={props.onChangeQuantity}
																			onSelect={props.onSelect}
																			tablestyle={tableSelstyle}
																			itemInfo={props.itemInfo}
																			onMouseEnter={props.onMouseEnter}
																			onMouseLeave={props.onMouseLeave}
																			configType={props.configType}
																			color={bgColor}
																			activeArticle={props.activeArticle}
																			/>)}
							</div>
						)}
					</div>
				{props.type === 'Bucket'&&<div><div className={styles.table_total} style={{backgroundColor: bgColor,}}><span>Итого</span>
					<span>{props.totalPrice} руб</span>
				</div>
					<div style={{fontSize:'9px',fontWeight:'normal',paddingLeft:'10px',paddingTop:'5px'}}>* -указана прайсовая стоимость оборудования, точную цену уточняйте у партнеров компании.</div></div>

		}
				</div>
			);
		case 'corridor':
			tablestyle = (props.type === 'Bucket' ? {
				display: "grid",
				gridTemplateColumns: '29% 50% 15% 6%',
				cursor: 'pointer'
			} : {display: "grid", gridTemplateColumns: '29% 64% 7%', cursor: 'pointer'})

			return (<div className={styles.wrapper} style={props.styles}>
					<div className={styles.table_head + ' ' + styles.table_name}
							 style={{backgroundColor: bgColor}}>{props.title}</div>
					<div className={styles.table_head} style={{backgroundColor: bgColor}}>
						<div style={tablestyle}>
							<div className={styles.sell} style={{border: "1px solid " + bgColor}}>Артикул</div>
							<div className={styles.sell}>Наименование</div>
							{props.type === 'Bucket'
								? <React.Fragment>
									<div className={styles.sell} style={{border: "1px solid " + bgColor}}>Кол-во</div>
									<div className={styles.sell} style={{border: "1px solid " + bgColor}}/>
								</React.Fragment>
								: <div className={styles.sell} style={{border: "1px solid " + bgColor}}/>}
						</div>
					</div>
					<div className={styles.itemList}>
						{props.items.map((item, index) =>
							<TableCorridorGroup
								key={index + Date.now()}
								item={item}
								index={index + 1}
								bgColor={bgColor}
								type={props.type}
								addInfo={props.addInfo}
								onDelete={props.onDelete}
								addBasket={props.addBasket}
								onChangeQuantity={props.onChangeQuantity}
								onSelect={props.onSelect}
								onGroupDelete={props.onGroupDelete}
								tablestyle={tablestyle}
								itemInfo={props.itemInfo}
								onMouseEnter={props.onMouseEnter}
								onMouseLeave={props.onMouseLeave}
								color={bgColor}
							/>)}
					</div>
				</div>
			);
		default:
			tablestyle = (props.type === 'Bucket' ? {
				display: "grid",
				gridTemplateColumns: '29% 50% 15% 6%',
				cursor: 'pointer'
			} : {display: "grid", gridTemplateColumns: '29% 64% 7%', cursor: 'pointer'})

			return (<div className={styles.wrapper} style={props.styles}>
					<div className={styles.table_head + ' ' + styles.table_name}
							 style={{backgroundColor: bgColor}}>{props.title}</div>
					<div className={styles.table_head} style={{backgroundColor: bgColor}}>
						<div style={tablestyle}>
							<div className={styles.sell} style={{border: "1px solid " + bgColor}}>Артикул</div>
							<div className={styles.sell}>Наименование</div>
							{props.type === 'Bucket'
								? <React.Fragment>
									<div className={styles.sell} style={{border: "1px solid " + bgColor}}>Кол-во</div>
									<div className={styles.sell} style={{border: "1px solid " + bgColor}}/>
								</React.Fragment>
								: <div className={styles.sell} style={{border: "1px solid " + bgColor}}/>}
						</div>
					</div>
					<div className={styles.itemList}>
						{props.items.map((item, index) =>
							<TableRow
								key={index + Date.now()}
								item={item}
								type={props.type}
								addInfo={props.addInfo}
								onDelete={props.onDelete}
								addBasket={props.addBasket}
								onChangeQuantity={props.onChangeQuantity}
								onSelect={props.onSelect}
								tablestyle={tablestyle}
								itemInfo={props.itemInfo}
								onMouseEnter={props.onMouseEnter}
								onMouseLeave={props.onMouseLeave}
								configType={props.configType?props.configType:null}
								color={bgColor}
							/>)}
					</div>
				</div>
			);
	}
}

function TableSortRow(props) {
	let tableSelstyle = ({display: "grid", gridTemplateColumns: '22% 28% 16% 16% 11% 7%'})
	return (
		<React.Fragment>
			<div className={styles.table_head}
					 style={{backgroundColor: '#ffc93a'}}>{props.nameSolution(props.item[0])}</div>
			<div className={styles.itemList_noScroll}>
				{props.item[1].map((elem, index) =>
					<TableRow key={index + Date.now()}
										item={elem}
										type={props.type}
										addInfo={props.addInfo}
										onDelete={props.onDelete}
										addBasket={props.addBasket}
										onChangeQuantity={props.onChangeQuantity}
										onSelect={props.onSelect}
										tablestyle={tableSelstyle}
										itemInfo={props.itemInfo}
										onMouseEnter={props.onMouseEnter}
										onMouseLeave={props.onMouseLeave}
										configType={props.configType}
										color={props.color}
					/>)
				}
			</div>

		</React.Fragment>
	)
}

function TableRow(props) {

	switch (props.configType && props.configType) {
		case('bap'):
			return (
				<React.Fragment>

					{/* ++ Спеицальная секция для BAP*/}
					{props.type === 'BapList' && props.itemInfo && props.item.power && props.item.limit && props.BapListHover &&
						<span
							style={{
								position: 'fixed',
								background: 'rgb(254, 254, 254)',
								fontSize: '14px',
								top: '135px',
								zIndex: 9999,
								border: '1px solid #000',
								padding: '7px',
								maxWidth: ' 447px',
								borderRadius: '4px',
							}}
						>
						Внимание! В комплекте с данным БАП светильник отработает {Math.round(props.item.power / props.itemInfo.power * 60)} минут, пропорционально превышению мощности
					</span>}
					{/* -- Спеицальная секция для BAP*/}

					<div
						className={(props.itemInfo && props.itemInfo.article) === props.item.article ? styles.itemInfo : ''}
						style={props.tablestyle}>
						<div className={styles.sell} style={{border: "1px solid " + bgColor}}
								 onClick={() => props.onSelect && props.onSelect(props.item)}>
							{props.item.article}
						</div>

						{props.type === 'BapList' && props.itemInfo && props.item.power && props.item.limit
							? <React.Fragment>
								<div className={styles.sell} style={{border: "1px solid " + props.color}}
										 onClick={() => props.onSelect && props.onSelect(props.item)}>
									<svg
										onMouseEnter={() => props.onMouseEnter && props.onMouseEnter()}
										onMouseLeave={() => props.onMouseLeave && props.onMouseLeave()}
										style={{
											position: 'relative',
											top: '6px',
											marginRight: '5px',
											marginBottom: '5px'
										}}
										xmlns="http://www.w3.org/2000/svg" height="12px" viewBox="0 0 24 24" width="12px"
										fill="#000000">
										<path d="M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"/>
									</svg>
									{props.item.name}
								</div>
							</ React.Fragment>
							: <div className={styles.sell} style={{border: "1px solid " + props.color}}
										 onClick={() => props.onSelect && props.onSelect(props.item)}>
								<span>{props.item.name}</span>
							</div>
						}

						{props.type === 'Bucket'
							? <React.Fragment>
								<div className={styles.symbol}>
									<input
										type="number"
										min="1"
										className="form-control"
										style={{width: '40px', border: "1px solid " + props.color}}
										defaultValue={props.item.count}
										onBlur={e => props.onChangeQuantity(props.item, e.target.value)}
									/>
								</div>
								<div
									className={styles.symbol}
									style={{border: "1px solid " + props.color}}
									onClick={() => props.onDelete(props.item)}>
									&#10006;
								</div>
							</React.Fragment>
							: <div className={styles.symbol}
										 style={{paddingTop: '2px', border: "1px solid " + props.color}}
										 onClick={() => {
											 props.addBasket(props.item)
										 }}>
								<svg id="Layer_1" height="16" viewBox="0 0 511.728 511.728" width="16"
										 xmlns="http://www.w3.org/2000/svg">
									<path
										d="m147.925 379.116c-22.357-1.142-21.936-32.588-.001-33.68 62.135.216 226.021.058 290.132.103 17.535 0 32.537-11.933 36.481-29.017l36.404-157.641c2.085-9.026-.019-18.368-5.771-25.629s-14.363-11.484-23.626-11.484c-25.791 0-244.716-.991-356.849-1.438l-17.775-65.953c-4.267-15.761-18.65-26.768-34.978-26.768h-56.942c-8.284 0-15 6.716-15 15s6.716 15 15 15h56.942c2.811 0 5.286 1.895 6.017 4.592l68.265 253.276c-12.003.436-23.183 5.318-31.661 13.92-8.908 9.04-13.692 21.006-13.471 33.695.442 25.377 21.451 46.023 46.833 46.023h21.872c-3.251 6.824-5.076 14.453-5.076 22.501 0 28.95 23.552 52.502 52.502 52.502s52.502-23.552 52.502-52.502c0-8.049-1.826-15.677-5.077-22.501h94.716c-3.248 6.822-5.073 14.447-5.073 22.493 0 28.95 23.553 52.502 52.502 52.502 28.95 0 52.503-23.553 52.503-52.502 0-8.359-1.974-16.263-5.464-23.285 5.936-1.999 10.216-7.598 10.216-14.207 0-8.284-6.716-15-15-15zm91.799 52.501c0 12.408-10.094 22.502-22.502 22.502s-22.502-10.094-22.502-22.502c0-12.401 10.084-22.491 22.483-22.501h.038c12.399.01 22.483 10.1 22.483 22.501zm167.07 22.494c-12.407 0-22.502-10.095-22.502-22.502 0-12.285 9.898-22.296 22.137-22.493h.731c12.24.197 22.138 10.208 22.138 22.493-.001 12.407-10.096 22.502-22.504 22.502zm74.86-302.233c.089.112.076.165.057.251l-15.339 66.425h-51.942l8.845-67.023 58.149.234c.089.002.142.002.23.113zm-154.645 163.66v-66.984h53.202l-8.84 66.984zm-74.382 0-8.912-66.984h53.294v66.984zm-69.053 0h-.047c-3.656-.001-6.877-2.467-7.828-5.98l-16.442-61.004h54.193l8.912 66.984zm56.149-96.983-9.021-67.799 66.306.267v67.532zm87.286 0v-67.411l66.022.266-8.861 67.145zm-126.588-67.922 9.037 67.921h-58.287l-18.38-68.194zm237.635 164.905h-36.426l8.84-66.984h48.973l-14.137 61.217c-.784 3.396-3.765 5.767-7.25 5.767z"/>
								</svg>
							</div>}
					</div>

				</ React.Fragment>
			)
		case('hatch'):
			return (
				<React.Fragment>

					<div
						className={(props.itemInfo && props.itemInfo.article) === props.item.article ? styles.itemInfo : ''}
						style={props.tablestyle}>
						<div className={styles.sell} style={{border: "1px solid " + props.color}}
								 onClick={() => props.onSelect && props.onSelect(props.item)}>
							{props.item.article}
						</div>

						<div className={styles.sell} style={{border: "1px solid " + props.color}}
								 onClick={() => props.onSelect && props.onSelect(props.item)}>
							<span>{props.item.name}</span>
						</div>

						{props.type === 'Bucket'
							? <React.Fragment>
								<div className={styles.sell + ' ' + styles.sell_price}
										 style={{border: "1px solid " + props.color}}>{props.item.price}</div>
								<div className={styles.sell + ' ' + styles.sell_price} style={{border: "1px solid " + props.color}}>
									<span>{props.item.sum}</span></div>
								<div className={styles.symbol}
										 style={{border: "1px solid " + props.color}}
								>
									<input
										type="number"
										min="1"
										className="form-control"
										style={{width: '40px', border: "1px solid " + props.color}}
										defaultValue={props.item.count}
										onBlur={e => props.onChangeQuantity(props.item, e.target.value)}
									/>
								</div>
								<div
									className={styles.symbol}
									style={{border: "1px solid " + props.color}}
									onClick={() => props.onDelete(props.item)}>
									&#10006;
								</div>
							</React.Fragment>
							: <div className={styles.symbol}
										 style={{paddingTop: '2px', border: "1px solid " + props.color}}
										 onClick={() => {
											 props.addBasket(props.item)
										 }}>
								<svg id="Layer_1" height="16" viewBox="0 0 511.728 511.728" width="16"
										 xmlns="http://www.w3.org/2000/svg">
									<path
										d="m147.925 379.116c-22.357-1.142-21.936-32.588-.001-33.68 62.135.216 226.021.058 290.132.103 17.535 0 32.537-11.933 36.481-29.017l36.404-157.641c2.085-9.026-.019-18.368-5.771-25.629s-14.363-11.484-23.626-11.484c-25.791 0-244.716-.991-356.849-1.438l-17.775-65.953c-4.267-15.761-18.65-26.768-34.978-26.768h-56.942c-8.284 0-15 6.716-15 15s6.716 15 15 15h56.942c2.811 0 5.286 1.895 6.017 4.592l68.265 253.276c-12.003.436-23.183 5.318-31.661 13.92-8.908 9.04-13.692 21.006-13.471 33.695.442 25.377 21.451 46.023 46.833 46.023h21.872c-3.251 6.824-5.076 14.453-5.076 22.501 0 28.95 23.552 52.502 52.502 52.502s52.502-23.552 52.502-52.502c0-8.049-1.826-15.677-5.077-22.501h94.716c-3.248 6.822-5.073 14.447-5.073 22.493 0 28.95 23.553 52.502 52.502 52.502 28.95 0 52.503-23.553 52.503-52.502 0-8.359-1.974-16.263-5.464-23.285 5.936-1.999 10.216-7.598 10.216-14.207 0-8.284-6.716-15-15-15zm91.799 52.501c0 12.408-10.094 22.502-22.502 22.502s-22.502-10.094-22.502-22.502c0-12.401 10.084-22.491 22.483-22.501h.038c12.399.01 22.483 10.1 22.483 22.501zm167.07 22.494c-12.407 0-22.502-10.095-22.502-22.502 0-12.285 9.898-22.296 22.137-22.493h.731c12.24.197 22.138 10.208 22.138 22.493-.001 12.407-10.096 22.502-22.504 22.502zm74.86-302.233c.089.112.076.165.057.251l-15.339 66.425h-51.942l8.845-67.023 58.149.234c.089.002.142.002.23.113zm-154.645 163.66v-66.984h53.202l-8.84 66.984zm-74.382 0-8.912-66.984h53.294v66.984zm-69.053 0h-.047c-3.656-.001-6.877-2.467-7.828-5.98l-16.442-61.004h54.193l8.912 66.984zm56.149-96.983-9.021-67.799 66.306.267v67.532zm87.286 0v-67.411l66.022.266-8.861 67.145zm-126.588-67.922 9.037 67.921h-58.287l-18.38-68.194zm237.635 164.905h-36.426l8.84-66.984h48.973l-14.137 61.217c-.784 3.396-3.765 5.767-7.25 5.767z"/>
								</svg>
							</div>}
					</div>

				</ React.Fragment>
			)
		case('hatchSep'):
			return (
				<React.Fragment>

					<div
						className={(props.itemInfo && props.itemInfo.article) === props.item.article ? styles.itemInfo : ''}
						style={props.tablestyle}>
						<div className={styles.sell} style={{border: "1px solid " + props.color}}
								 onClick={() => props.onSelect && props.onSelect(props.item)}>
							{props.item.article}
						</div>

						<div className={styles.sell} style={{border: "1px solid " + props.color}}
								 onClick={() => props.onSelect && props.onSelect(props.item)}>
							<span>{props.item.name}</span>
						</div>

						{props.type === 'Bucket'
							? <React.Fragment>
								<div className={styles.sell + ' ' + styles.sell_price}
										 style={{border: "1px solid " + props.color}}>{props.item.price}</div>
								<div className={styles.sell + ' ' + styles.sell_price} style={{border: "1px solid " + props.color}}>
									<span>{props.item.sum}</span></div>
								<div className={styles.symbol}
										 style={{border: "1px solid " + props.color}}
								>
									<input
										type="number"
										min="1"
										className="form-control"
										style={{width: '40px', border: "1px solid " + props.color}}
										defaultValue={props.item.count}
										onBlur={e => props.onChangeQuantity(props.item, e.target.value)}
									/>
								</div>
								<div
									className={styles.symbol}
									style={{border: "1px solid " + props.color}}
									onClick={() => props.onDelete(props.item)}>
									&#10006;
								</div>
							</React.Fragment>
							: <div className={styles.symbol}
										 style={{paddingTop: '2px', border: "1px solid " + props.color}}
										 onClick={() => {
											 props.addBasket(props.item)
										 }
										 }>
								<svg id="Layer_1" height="16" viewBox="0 0 511.728 511.728" width="16"
										 xmlns="http://www.w3.org/2000/svg">
									<path
										d="m147.925 379.116c-22.357-1.142-21.936-32.588-.001-33.68 62.135.216 226.021.058 290.132.103 17.535 0 32.537-11.933 36.481-29.017l36.404-157.641c2.085-9.026-.019-18.368-5.771-25.629s-14.363-11.484-23.626-11.484c-25.791 0-244.716-.991-356.849-1.438l-17.775-65.953c-4.267-15.761-18.65-26.768-34.978-26.768h-56.942c-8.284 0-15 6.716-15 15s6.716 15 15 15h56.942c2.811 0 5.286 1.895 6.017 4.592l68.265 253.276c-12.003.436-23.183 5.318-31.661 13.92-8.908 9.04-13.692 21.006-13.471 33.695.442 25.377 21.451 46.023 46.833 46.023h21.872c-3.251 6.824-5.076 14.453-5.076 22.501 0 28.95 23.552 52.502 52.502 52.502s52.502-23.552 52.502-52.502c0-8.049-1.826-15.677-5.077-22.501h94.716c-3.248 6.822-5.073 14.447-5.073 22.493 0 28.95 23.553 52.502 52.502 52.502 28.95 0 52.503-23.553 52.503-52.502 0-8.359-1.974-16.263-5.464-23.285 5.936-1.999 10.216-7.598 10.216-14.207 0-8.284-6.716-15-15-15zm91.799 52.501c0 12.408-10.094 22.502-22.502 22.502s-22.502-10.094-22.502-22.502c0-12.401 10.084-22.491 22.483-22.501h.038c12.399.01 22.483 10.1 22.483 22.501zm167.07 22.494c-12.407 0-22.502-10.095-22.502-22.502 0-12.285 9.898-22.296 22.137-22.493h.731c12.24.197 22.138 10.208 22.138 22.493-.001 12.407-10.096 22.502-22.504 22.502zm74.86-302.233c.089.112.076.165.057.251l-15.339 66.425h-51.942l8.845-67.023 58.149.234c.089.002.142.002.23.113zm-154.645 163.66v-66.984h53.202l-8.84 66.984zm-74.382 0-8.912-66.984h53.294v66.984zm-69.053 0h-.047c-3.656-.001-6.877-2.467-7.828-5.98l-16.442-61.004h54.193l8.912 66.984zm56.149-96.983-9.021-67.799 66.306.267v67.532zm87.286 0v-67.411l66.022.266-8.861 67.145zm-126.588-67.922 9.037 67.921h-58.287l-18.38-68.194zm237.635 164.905h-36.426l8.84-66.984h48.973l-14.137 61.217c-.784 3.396-3.765 5.767-7.25 5.767z"/>
								</svg>
							</div>}
					</div>

				</ React.Fragment>
			)
		case('power'):
		case('lan'):
		case('optic'):
		case('ibp'):
			return getTableRowWithPrice(props)
		case ('pipe'):
			return (
				<React.Fragment>

					<div
						className={(props.itemInfo && props.itemInfo.article) === props.item.article ? styles.itemInfo : ''}
						style={props.tablestyle}>
						{props.type === 'Cable' ? <React.Fragment>
							<div className={styles.sell}
									 style={{border: "1px solid " + props.color, backgroundColor: 'white'}}
									 onClick={() => props.onSelect && props.onSelect(props.item)}>
								<span>{props.item.name}</span>
							</div>
							<div style={{width: '100%', textAlign: 'center'}}>
								<select
									style={{
										width: '100%',
										border: "1px solid " + props.color,
										textAlign: 'center'
									}}
									onChange={e => props.onSelectCable(e.target.value, props.item)}
									defaultValue={props.item.selected}>
									{props.item.size.length > 0 ?
										props.item.size.map((option, index) => {
											return (
												<option value={option} key={index + option}>{option} </option>)
										})
										: <option value="Выбрать">Выбрать</option>
									}
								</select>
							</div>
							<div style={{width: '100%', textAlign: 'center'}}>
								<input type="number" defaultValue={props.item.count}
											 onBlur={e => props.onChangeQuantity(props.item, e.target.value, props.type)}
											 min="1"
											 className="form-control"
											 style={{
												 width: '100%',
												 border: "1px solid " + props.color,
												 textAlign: 'center'

											 }}/></div>


						</React.Fragment> : <React.Fragment>
							<div className={styles.sell} style={{border: "1px solid " + props.color, backgroundColor: 'white'}}
									 onClick={() => props.onSelect && props.onSelect(props.item)}>
								{props.item.article}
							</div>
							<div className={styles.sell} style={{border: "1px solid " + props.color, backgroundColor: 'white'}}
									 onClick={() => props.onSelect && props.onSelect(props.item)}>
								<span>{props.item.name}</span>
							</div>
						</React.Fragment>}
						{props.type === 'pipe' &&
							<div className={styles.sell}
									 style={{
										 border: "1px solid " + props.color,
										 backgroundColor: 'white',
										 textAlign: 'center'
									 }}
									 onClick={() => props.onSelect && props.onSelect(props.item)}>
								{props.item.percent.toFixed(2)} %
							</div>
						}


						{props.type === 'Bucket' &&
							<React.Fragment>
								<div className={styles.sell + ' ' + styles.sell_price}
										 style={{border: "1px solid " + props.color, backgroundColor: 'white'}}>{props.item.price}</div>
								<div className={styles.sell + ' ' + styles.sell_price}
										 style={{border: "1px solid " + props.color, backgroundColor: 'white'}}>
									<span>{props.item.sum}</span></div>
								<div className={styles.symbol}
										 style={{border: "1px solid " + props.color}}
								>
									<input
										type="number"
										min="1"
										className="form-control"
										style={{width: '40px', border: "1px solid " + props.color}}
										defaultValue={props.item.count}
										onBlur={e => props.onChangeQuantity(props.item, e.target.value, props.type)}
									/>
								</div>

							</React.Fragment>}
						{props.type === 'Bucket' || props.type === 'Cable' ? <div
							className={styles.symbol}
							style={{border: "1px solid " + props.color, backgroundColor: 'white'}}
							onClick={() => props.onDelete(props.item, props.type)}>
							&#10006;
						</div> : <div className={styles.symbol}
													style={{paddingTop: '2px', border: "1px solid " + props.color, backgroundColor: 'white'}}
													onClick={() => {
														props.addBasket(props.item)
													}
													}>
							<svg id="Layer_1" height="16" viewBox="0 0 511.728 511.728" width="16"
									 xmlns="http://www.w3.org/2000/svg">
								<path
									d="m147.925 379.116c-22.357-1.142-21.936-32.588-.001-33.68 62.135.216 226.021.058 290.132.103 17.535 0 32.537-11.933 36.481-29.017l36.404-157.641c2.085-9.026-.019-18.368-5.771-25.629s-14.363-11.484-23.626-11.484c-25.791 0-244.716-.991-356.849-1.438l-17.775-65.953c-4.267-15.761-18.65-26.768-34.978-26.768h-56.942c-8.284 0-15 6.716-15 15s6.716 15 15 15h56.942c2.811 0 5.286 1.895 6.017 4.592l68.265 253.276c-12.003.436-23.183 5.318-31.661 13.92-8.908 9.04-13.692 21.006-13.471 33.695.442 25.377 21.451 46.023 46.833 46.023h21.872c-3.251 6.824-5.076 14.453-5.076 22.501 0 28.95 23.552 52.502 52.502 52.502s52.502-23.552 52.502-52.502c0-8.049-1.826-15.677-5.077-22.501h94.716c-3.248 6.822-5.073 14.447-5.073 22.493 0 28.95 23.553 52.502 52.502 52.502 28.95 0 52.503-23.553 52.503-52.502 0-8.359-1.974-16.263-5.464-23.285 5.936-1.999 10.216-7.598 10.216-14.207 0-8.284-6.716-15-15-15zm91.799 52.501c0 12.408-10.094 22.502-22.502 22.502s-22.502-10.094-22.502-22.502c0-12.401 10.084-22.491 22.483-22.501h.038c12.399.01 22.483 10.1 22.483 22.501zm167.07 22.494c-12.407 0-22.502-10.095-22.502-22.502 0-12.285 9.898-22.296 22.137-22.493h.731c12.24.197 22.138 10.208 22.138 22.493-.001 12.407-10.096 22.502-22.504 22.502zm74.86-302.233c.089.112.076.165.057.251l-15.339 66.425h-51.942l8.845-67.023 58.149.234c.089.002.142.002.23.113zm-154.645 163.66v-66.984h53.202l-8.84 66.984zm-74.382 0-8.912-66.984h53.294v66.984zm-69.053 0h-.047c-3.656-.001-6.877-2.467-7.828-5.98l-16.442-61.004h54.193l8.912 66.984zm56.149-96.983-9.021-67.799 66.306.267v67.532zm87.286 0v-67.411l66.022.266-8.861 67.145zm-126.588-67.922 9.037 67.921h-58.287l-18.38-68.194zm237.635 164.905h-36.426l8.84-66.984h48.973l-14.137 61.217c-.784 3.396-3.765 5.767-7.25 5.767z"/>
							</svg>
						</div>}
						{props.type === 'Cable' && <div style={{textAlign: 'center', gridTemplateColumns: '1fr', padding: '5px'}}>
							Площадь сечения мм: {props.item.fullSize.toFixed(2)}
						</div>}
					</div>

				</ React.Fragment>
			)
		case 'ground_select':
			return (
				<React.Fragment>

					<div
						className={(props.itemInfo && props.itemInfo.article) === props.item.article ? styles.itemInfo : ''}
						style={props.tablestyle}>
						<div className={styles.sell} style={{border: "1px solid " + props.color, cursor:'auto'}}
								 // onClick={() => props.onSelect && props.onSelect(props.item)}
						>
							{props.item.article}
						</div>

						<div className={styles.sell} style={{border: "1px solid " + props.color}}
								 onClick={() => props.onSelect && props.onSelect(props.item)}>
							<span>{props.item.name}</span>
						</div>

						{props.type === 'Bucket'
							?
							<React.Fragment>
								<div className={styles.symbol}
										 style={{border: "1px solid " + props.color, cursor: props.item.disable ? 'not-allowed' : 'pointer'}}
								>
									<input
										type="number"
										min="1"
										className="form-control"
										style={{width: '60px', border: "1px solid " + props.color, cursor: props.item.disable ? 'not-allowed' : 'pointer' }}
										defaultValue={props.item.count}
										onBlur={e => props.onChangeQuantity(props.item, e.target.value)}
										disabled={props.item.disable}
									/>
								</div>
								<div
									className={styles.symbol}
									style={{border: "1px solid " + props.color, cursor: 'not-allowed'}}
									onClick={() => !props.item.disable && props.onDelete(props.item)}>
									&#10006;
								</div>
							</React.Fragment>
							: <div className={styles.symbol}
										 style={{paddingTop: '2px', border: "1px solid " + props.color}}
										 onClick={() => {
											 props.addBasket(props.item)

										 }}>
								<svg id="Layer_1" height="16" viewBox="0 0 511.728 511.728" width="16"
										 xmlns="http://www.w3.org/2000/svg">
									<path
										d="m147.925 379.116c-22.357-1.142-21.936-32.588-.001-33.68 62.135.216 226.021.058 290.132.103 17.535 0 32.537-11.933 36.481-29.017l36.404-157.641c2.085-9.026-.019-18.368-5.771-25.629s-14.363-11.484-23.626-11.484c-25.791 0-244.716-.991-356.849-1.438l-17.775-65.953c-4.267-15.761-18.65-26.768-34.978-26.768h-56.942c-8.284 0-15 6.716-15 15s6.716 15 15 15h56.942c2.811 0 5.286 1.895 6.017 4.592l68.265 253.276c-12.003.436-23.183 5.318-31.661 13.92-8.908 9.04-13.692 21.006-13.471 33.695.442 25.377 21.451 46.023 46.833 46.023h21.872c-3.251 6.824-5.076 14.453-5.076 22.501 0 28.95 23.552 52.502 52.502 52.502s52.502-23.552 52.502-52.502c0-8.049-1.826-15.677-5.077-22.501h94.716c-3.248 6.822-5.073 14.447-5.073 22.493 0 28.95 23.553 52.502 52.502 52.502 28.95 0 52.503-23.553 52.503-52.502 0-8.359-1.974-16.263-5.464-23.285 5.936-1.999 10.216-7.598 10.216-14.207 0-8.284-6.716-15-15-15zm91.799 52.501c0 12.408-10.094 22.502-22.502 22.502s-22.502-10.094-22.502-22.502c0-12.401 10.084-22.491 22.483-22.501h.038c12.399.01 22.483 10.1 22.483 22.501zm167.07 22.494c-12.407 0-22.502-10.095-22.502-22.502 0-12.285 9.898-22.296 22.137-22.493h.731c12.24.197 22.138 10.208 22.138 22.493-.001 12.407-10.096 22.502-22.504 22.502zm74.86-302.233c.089.112.076.165.057.251l-15.339 66.425h-51.942l8.845-67.023 58.149.234c.089.002.142.002.23.113zm-154.645 163.66v-66.984h53.202l-8.84 66.984zm-74.382 0-8.912-66.984h53.294v66.984zm-69.053 0h-.047c-3.656-.001-6.877-2.467-7.828-5.98l-16.442-61.004h54.193l8.912 66.984zm56.149-96.983-9.021-67.799 66.306.267v67.532zm87.286 0v-67.411l66.022.266-8.861 67.145zm-126.588-67.922 9.037 67.921h-58.287l-18.38-68.194zm237.635 164.905h-36.426l8.84-66.984h48.973l-14.137 61.217c-.784 3.396-3.765 5.767-7.25 5.767z"/>
								</svg>
							</div>}
					</div>

				</ React.Fragment>
			)

		case('enclosure_titan'):
			return (
				<React.Fragment>

					<div
						className={(props.itemInfo && props.itemInfo.article) === props.item.article ? styles.itemInfo : ''}
						style={props.item.article===props.activeArticle?props.type==='Bucket'?{
							display: "grid",
							gridTemplateColumns: '22% 28% 16% 16% 11% 7%',
							backgroundColor:'#ececec'}:{
							display: "grid",
							gridTemplateColumns: '29% 64% 7%',
							backgroundColor:'#ececec'}:props.tablestyle}>
						<div className={styles.sell} style={{border: "1px solid " + props.color}}
								 onClick={() => props.onSelect && props.onSelect(props.item)}>
							{props.item.article}
						</div>

						<div className={styles.sell} style={{border: "1px solid " + props.color}}
								 onClick={() => props.onSelect && props.onSelect(props.item)}>
							<span>{props.item.name}</span>
						</div>

						{props.type === 'Bucket'
							? <React.Fragment>
								<div className={styles.sell + ' ' + styles.sell_price}
										 style={{border: "1px solid " + props.color}}>{props.item.price}</div>
								<div className={styles.sell + ' ' + styles.sell_price} style={{border: "1px solid " + props.color}}>
									<span>{props.item.sum}</span></div>
								<div className={styles.symbol}
										 style={{border: "1px solid " + props.color}}
								>
									<input
										type="number"
										min="1"
										className="form-control"
										style={{width: '40px', border: "1px solid " + props.color}}
										defaultValue={props.item.count}
										onBlur={e => props.onChangeQuantity(props.item, e.target.value)}
									/>
								</div>
								<div
									className={styles.symbol}
									style={{border: "1px solid " + props.color}}
									onClick={() => props.onDelete(props.item)}>
									&#10006;
								</div>
							</React.Fragment>
							: <div className={styles.symbol}
										 style={{paddingTop: '2px', border: "1px solid " + props.color}}
										 onClick={() => {
											 props.addBasket(props.item)
										 }}>
								<svg id="Layer_1" height="16" viewBox="0 0 511.728 511.728" width="16"
										 xmlns="http://www.w3.org/2000/svg">
									<path
										d="m147.925 379.116c-22.357-1.142-21.936-32.588-.001-33.68 62.135.216 226.021.058 290.132.103 17.535 0 32.537-11.933 36.481-29.017l36.404-157.641c2.085-9.026-.019-18.368-5.771-25.629s-14.363-11.484-23.626-11.484c-25.791 0-244.716-.991-356.849-1.438l-17.775-65.953c-4.267-15.761-18.65-26.768-34.978-26.768h-56.942c-8.284 0-15 6.716-15 15s6.716 15 15 15h56.942c2.811 0 5.286 1.895 6.017 4.592l68.265 253.276c-12.003.436-23.183 5.318-31.661 13.92-8.908 9.04-13.692 21.006-13.471 33.695.442 25.377 21.451 46.023 46.833 46.023h21.872c-3.251 6.824-5.076 14.453-5.076 22.501 0 28.95 23.552 52.502 52.502 52.502s52.502-23.552 52.502-52.502c0-8.049-1.826-15.677-5.077-22.501h94.716c-3.248 6.822-5.073 14.447-5.073 22.493 0 28.95 23.553 52.502 52.502 52.502 28.95 0 52.503-23.553 52.503-52.502 0-8.359-1.974-16.263-5.464-23.285 5.936-1.999 10.216-7.598 10.216-14.207 0-8.284-6.716-15-15-15zm91.799 52.501c0 12.408-10.094 22.502-22.502 22.502s-22.502-10.094-22.502-22.502c0-12.401 10.084-22.491 22.483-22.501h.038c12.399.01 22.483 10.1 22.483 22.501zm167.07 22.494c-12.407 0-22.502-10.095-22.502-22.502 0-12.285 9.898-22.296 22.137-22.493h.731c12.24.197 22.138 10.208 22.138 22.493-.001 12.407-10.096 22.502-22.504 22.502zm74.86-302.233c.089.112.076.165.057.251l-15.339 66.425h-51.942l8.845-67.023 58.149.234c.089.002.142.002.23.113zm-154.645 163.66v-66.984h53.202l-8.84 66.984zm-74.382 0-8.912-66.984h53.294v66.984zm-69.053 0h-.047c-3.656-.001-6.877-2.467-7.828-5.98l-16.442-61.004h54.193l8.912 66.984zm56.149-96.983-9.021-67.799 66.306.267v67.532zm87.286 0v-67.411l66.022.266-8.861 67.145zm-126.588-67.922 9.037 67.921h-58.287l-18.38-68.194zm237.635 164.905h-36.426l8.84-66.984h48.973l-14.137 61.217c-.784 3.396-3.765 5.767-7.25 5.767z"/>
								</svg>
							</div>}
					</div>

				</ React.Fragment>
			)

		case ('bapLabel'):
			return (
				<React.Fragment>

					<div
						className={(props.itemInfo && props.itemInfo.article) === props.item.article ? styles.itemInfo : ''}
						style={props.tablestyle}>
						<div className={styles.sell} style={{border: "1px solid " + props.color}}
								 onClick={() => props.onSelect && props.onSelect(props.item)}>
							{props.item.article}
						</div>

						<div className={styles.sell} style={{border: "1px solid " + props.color}}
								 onClick={() => props.onSelect && props.onSelect(props.item)}>
							<span>{props.item.name}</span>
						</div>

						{props.type === 'Bucket'
							? <React.Fragment>
								<div className={styles.symbol}
										 style={{border: "1px solid " + props.color}}
								>
									<input
										type="number"
										min="1"
										className="form-control"
										style={{width: '40px', border: "1px solid " + props.color}}
										defaultValue={props.item.count}
										onBlur={e => props.onChangeQuantity(props.item, e.target.value)}
									/>
								</div>
								<div
									className={styles.symbol}
									style={{border: "1px solid " + props.color}}
									onClick={() => props.onDelete(props.item)}>
									&#10006;
								</div>
							</React.Fragment>
							: <div className={styles.symbol}
										 style={{paddingTop: '2px', border: "1px solid " + props.color}}
										 onClick={() => {
											 props.addBasket(props.item)

										 }}>
								<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
								width="15" height="15" viewBox="0 0 1280.000000 1270.000000"
								>
								<g transform="translate(0.000000,1270.000000) scale(0.100000,-0.100000)"
									 fill="#000000" stroke="none">
									<path d="M4895 12689 c-1613 -102 -3112 -968 -4012 -2319 -694 -1043 -991
-2273 -847 -3520 185 -1607 1121 -3058 2509 -3887 677 -405 1361 -632 2180
-723 156 -18 716 -24 895 -11 870 67 1729 349 2424 798 l69 45 1516 -1515
c834 -833 1532 -1523 1551 -1534 52 -27 193 -25 285 6 100 33 247 111 336 178
123 93 205 171 493 469 286 294 357 383 431 540 74 155 94 317 51 404 -10 19
-696 714 -1544 1562 -1479 1480 -1526 1529 -1513 1550 262 420 497 991 620
1508 151 636 181 1333 85 1995 -180 1243 -840 2421 -1814 3237 -1041 872
-2355 1303 -3715 1217z m590 -1739 c1099 -82 2065 -645 2673 -1560 310 -466
492 -968 564 -1560 17 -140 17 -602 -1 -745 -72 -597 -264 -1119 -588 -1595
-427 -626 -1048 -1102 -1753 -1342 -369 -125 -670 -178 -1070 -185 -271 -5
-440 7 -672 47 -1565 273 -2755 1574 -2889 3158 -15 179 -6 582 16 742 55 398
155 729 330 1085 183 374 396 670 695 964 706 696 1707 1064 2695 991z"/>
								</g>
							</svg>
							</div>}
					</div>

				</ React.Fragment>
			)
		default:

			return (
				<React.Fragment>

					<div
						className={(props.itemInfo && props.itemInfo.article) === props.item.article ? styles.itemInfo : ''}
						style={props.tablestyle}>
						<div className={styles.sell} style={{border: "1px solid " + props.color}}
								 onClick={() => props.onSelect && props.onSelect(props.item)}>
							{props.item.article}
						</div>

						<div className={styles.sell} style={{border: "1px solid " + props.color}}
								 onClick={() => props.onSelect && props.onSelect(props.item)}>
							<span>{props.item.name}</span>
						</div>

						{props.type === 'Bucket'
							? <React.Fragment>
								<div className={styles.symbol}
										 style={{border: "1px solid " + props.color}}
								>
									<input
										type="number"
										min="1"
										className="form-control"
										style={{width: '40px', border: "1px solid " + props.color}}
										defaultValue={props.item.count}
										onBlur={e => props.onChangeQuantity(props.item, e.target.value)}
									/>
								</div>
								<div
									className={styles.symbol}
									style={{border: "1px solid " + props.color}}
									onClick={() => props.onDelete(props.item)}>
									&#10006;
								</div>
							</React.Fragment>
							: <div className={styles.symbol}
										 style={{paddingTop: '2px', border: "1px solid " + props.color}}
										 onClick={() => {
											 props.addBasket(props.item)

										 }}>
								<svg id="Layer_1" height="16" viewBox="0 0 511.728 511.728" width="16"
										 xmlns="http://www.w3.org/2000/svg">
									<path
										d="m147.925 379.116c-22.357-1.142-21.936-32.588-.001-33.68 62.135.216 226.021.058 290.132.103 17.535 0 32.537-11.933 36.481-29.017l36.404-157.641c2.085-9.026-.019-18.368-5.771-25.629s-14.363-11.484-23.626-11.484c-25.791 0-244.716-.991-356.849-1.438l-17.775-65.953c-4.267-15.761-18.65-26.768-34.978-26.768h-56.942c-8.284 0-15 6.716-15 15s6.716 15 15 15h56.942c2.811 0 5.286 1.895 6.017 4.592l68.265 253.276c-12.003.436-23.183 5.318-31.661 13.92-8.908 9.04-13.692 21.006-13.471 33.695.442 25.377 21.451 46.023 46.833 46.023h21.872c-3.251 6.824-5.076 14.453-5.076 22.501 0 28.95 23.552 52.502 52.502 52.502s52.502-23.552 52.502-52.502c0-8.049-1.826-15.677-5.077-22.501h94.716c-3.248 6.822-5.073 14.447-5.073 22.493 0 28.95 23.553 52.502 52.502 52.502 28.95 0 52.503-23.553 52.503-52.502 0-8.359-1.974-16.263-5.464-23.285 5.936-1.999 10.216-7.598 10.216-14.207 0-8.284-6.716-15-15-15zm91.799 52.501c0 12.408-10.094 22.502-22.502 22.502s-22.502-10.094-22.502-22.502c0-12.401 10.084-22.491 22.483-22.501h.038c12.399.01 22.483 10.1 22.483 22.501zm167.07 22.494c-12.407 0-22.502-10.095-22.502-22.502 0-12.285 9.898-22.296 22.137-22.493h.731c12.24.197 22.138 10.208 22.138 22.493-.001 12.407-10.096 22.502-22.504 22.502zm74.86-302.233c.089.112.076.165.057.251l-15.339 66.425h-51.942l8.845-67.023 58.149.234c.089.002.142.002.23.113zm-154.645 163.66v-66.984h53.202l-8.84 66.984zm-74.382 0-8.912-66.984h53.294v66.984zm-69.053 0h-.047c-3.656-.001-6.877-2.467-7.828-5.98l-16.442-61.004h54.193l8.912 66.984zm56.149-96.983-9.021-67.799 66.306.267v67.532zm87.286 0v-67.411l66.022.266-8.861 67.145zm-126.588-67.922 9.037 67.921h-58.287l-18.38-68.194zm237.635 164.905h-36.426l8.84-66.984h48.973l-14.137 61.217c-.784 3.396-3.765 5.767-7.25 5.767z"/>
								</svg>
							</div>}
					</div>

				</ React.Fragment>
			)

	}
}

function TableCorridorGroup(props) {
	return (<React.Fragment>
		<div className={styles.table_head} style={{
			backgroundColor: props.bgColor,
			display: 'grid',
			gridTemplateColumns: '94% 6%'
		}}>
			<div>
				{'Конфигурация коридора №' + props.index}
			</div>
			<div
				className={styles.symbol}
				style={{border: "1px solid " + props.color, backgroundColor: '#fff', height: '20px'}}
				onClick={() => props.onGroupDelete(props.item)}>
				&#10006;
			</div>
		</div>
		<div className={styles.corridorList}>
			{props.item.data.map((row, inx) =>
				<TableRow
					key={inx + Date.now()}
					item={row}
					type={props.type}
					addInfo={props.addInfo}
					onDelete={props.onDelete}
					addBasket={props.addBasket}
					onChangeQuantity={props.onChangeQuantity}
					onSelect={props.onSelect}
					tablestyle={props.tablestyle}
					itemInfo={props.itemInfo}
					onMouseEnter={props.onMouseEnter}
					onMouseLeave={props.onMouseLeave}
					color={props.bgColor}
				/>)}
		</div>
	</React.Fragment>)
}

function TableRowPipeCable(props) {
	let tableSelstyle = ({display: "grid", gridTemplateColumns: '40% 30% 30%'})
	let itemstyle = ({
		textAlign: 'center',
		border: "2px solid white",
		borderRight: 0,
		borderLeft: 0,
		backgroundColor: '#d4d3d3',
		padding: '5px'
	})
	return (<React.Fragment>
		<div style={tableSelstyle}>
			<div className={styles.sell}
					 style={itemstyle}>
				<span>{props.item.name}</span>
			</div>
			<div
				style={itemstyle}>
				Сечение: {props.item.selected}
			</div>
			<div style={itemstyle}>
				Количество: {props.item.count}</div>
		</div>

	</React.Fragment>)
}
function TableRowAccessoryTitan(props) {
	let tableSelstyle = (props.item.article===props.activeArticle?
		{display: "grid", gridTemplateColumns: '22% 28% 16% 16% 11% 7%',backgroundColor:'#ececec'}:
		{display: "grid", gridTemplateColumns: '22% 28% 16% 16% 11% 7%'})
	// let itemstyle = ({
	// 	textAlign: 'center',
	// 	border: "2px solid white",
	// 	borderRight: 0,
	// 	borderLeft: 0,
	// 	backgroundColor: '#d4d3d3',
	// 	padding: '5px'
	// })
	return (<React.Fragment>

		<div
			className={(props.itemInfo && props.itemInfo.article) === props.item.article ? styles.itemInfo : ''}
			style={tableSelstyle}>
			<div className={styles.sell} style={{border: "1px solid " + props.color}}
					 onClick={() => props.onSelect && props.onSelect(props.item)}>
				{props.item.article}
			</div>

			<div className={styles.sell} style={{border: "1px solid " + props.color}}
					 onClick={() => props.onSelect && props.onSelect(props.item)}>
				<span>{props.item.name}</span>
			</div>
					<div className={styles.sell + ' ' + styles.sell_price}
							 style={{border: "1px solid " + props.color}}>{props.item.price}</div>
					<div className={styles.sell + ' ' + styles.sell_price} style={{border: "1px solid " + props.color}}>
						<span>{props.item.sum}</span></div>
					<div className={styles.symbol}
							 style={{border: "1px solid " + props.color}}
					>
						<input
							type="number"
							min="1"
							className="form-control"
							style={{width: '40px', border: "1px solid " + props.color}}
							defaultValue={props.item.count}
							onBlur={e => props.onChangeQuantity(props.item, e.target.value)}
						/>
					</div>
					<div
						className={styles.symbol}
						style={{border: "1px solid " + props.color}}
						onClick={() => props.onDelete(props.item)}>
						&#10006;
					</div>

		</div>

	</React.Fragment>)
}

function TableWithPrice(props) {

	return (<div id={props.id ? props.id : ''} className={styles.wrapper} style={props.styles}>
			<div className={styles.table_head + ' ' + styles.table_name}
					 style={{backgroundColor: props.bgColor}}>{props.title}</div>
			<div className={styles.table_head} style={{backgroundColor: props.bgColor}}>
				<div style={props.tablestyle}>
					<div className={styles.sell} style={{border: "1px solid " + props.bgColor}}>Артикул</div>
					<div className={styles.sell} style={{border: "1px solid " + props.bgColor}}>Наименование</div>
					{props.type === 'Bucket'
						? <React.Fragment>
							<div className={styles.sell} style={{border: "1px solid " + props.bgColor}}>Цена</div>
							<div className={styles.sell} style={{border: "1px solid " + props.bgColor}}>Сумма</div>
							<div className={styles.sell} style={{border: "1px solid " + props.bgColor}}>Кол-во</div>
							<div className={styles.sell} style={{border: "1px solid " + props.bgColor}}/>
						</React.Fragment>
						: <div className={styles.sell} style={{border: "1px solid " + props.bgColor}}/>}
				</div>
			</div>
			<div className={styles.itemList}>
				{props.items.map((item, index) =>
					<TableRow
						key={index + Date.now()}
						item={item}
						type={props.type}
						addInfo={props.addInfo}
						onDelete={props.onDelete}
						addBasket={props.addBasket}
						onChangeQuantity={props.onChangeQuantity}
						onSelect={props.onSelect}
						tablestyle={props.tableSelstyle}
						itemInfo={props.itemInfo}
						color={props.bgColor}
						configType={props.configType}
					/>)}
			</div>
		</div>
	);

}

function getTableRowWithPrice(props) {
	return (
		<div
			style={props.tablestyle}
		>
			<div className={styles.sell} style={{border: "1px solid " + props.color}} onClick={() => {
				props.onSelect && props.onSelect(props.item)
			}}>
				<span>{props.item.article}</span>
			</div>
			<div className={styles.sell} style={{border: "1px solid " + props.color}} onClick={() => {
				props.onSelect && props.onSelect(props.item)
			}}>
				<span>{props.item.name}</span>
			</div>
			{props.type === 'Bucket'
				? <React.Fragment>
					<div className={styles.sell} style={{border: "1px solid " + props.color}}><span>{props.item.price}</span>
					</div>
					<div className={styles.sell} style={{border: "1px solid " + props.color}}><span>{props.item.sum}</span></div>
					<div className={styles.symbol} style={{border: "1px solid " + props.color}}>
						<input
							type="number"
							min="1"
							style={{width: '40px', border: "1px solid " + props.color}}
							defaultValue={props.item.count}
							onBlur={e => props.onChangeQuantity(props.item, e.target.value)}
						/>
					</div>
					<div
						className={styles.symbol}
						style={{border: "1px solid " + props.color}}
						onClick={() => props.onDelete(props.item)}>
						&#10006;
					</div>
				</React.Fragment>
				: <div className={styles.symbol}
							 style={{paddingTop: '2px', border: "1px solid " + props.color}}
							 onClick={() => {
								 props.addBasket(props.item)
							 }}>
					<svg id="Layer_1" height="16" viewBox="0 0 511.728 511.728" width="16" xmlns="http://www.w3.org/2000/svg">
						<path
							d="m147.925 379.116c-22.357-1.142-21.936-32.588-.001-33.68 62.135.216 226.021.058 290.132.103 17.535 0 32.537-11.933 36.481-29.017l36.404-157.641c2.085-9.026-.019-18.368-5.771-25.629s-14.363-11.484-23.626-11.484c-25.791 0-244.716-.991-356.849-1.438l-17.775-65.953c-4.267-15.761-18.65-26.768-34.978-26.768h-56.942c-8.284 0-15 6.716-15 15s6.716 15 15 15h56.942c2.811 0 5.286 1.895 6.017 4.592l68.265 253.276c-12.003.436-23.183 5.318-31.661 13.92-8.908 9.04-13.692 21.006-13.471 33.695.442 25.377 21.451 46.023 46.833 46.023h21.872c-3.251 6.824-5.076 14.453-5.076 22.501 0 28.95 23.552 52.502 52.502 52.502s52.502-23.552 52.502-52.502c0-8.049-1.826-15.677-5.077-22.501h94.716c-3.248 6.822-5.073 14.447-5.073 22.493 0 28.95 23.553 52.502 52.502 52.502 28.95 0 52.503-23.553 52.503-52.502 0-8.359-1.974-16.263-5.464-23.285 5.936-1.999 10.216-7.598 10.216-14.207 0-8.284-6.716-15-15-15zm91.799 52.501c0 12.408-10.094 22.502-22.502 22.502s-22.502-10.094-22.502-22.502c0-12.401 10.084-22.491 22.483-22.501h.038c12.399.01 22.483 10.1 22.483 22.501zm167.07 22.494c-12.407 0-22.502-10.095-22.502-22.502 0-12.285 9.898-22.296 22.137-22.493h.731c12.24.197 22.138 10.208 22.138 22.493-.001 12.407-10.096 22.502-22.504 22.502zm74.86-302.233c.089.112.076.165.057.251l-15.339 66.425h-51.942l8.845-67.023 58.149.234c.089.002.142.002.23.113zm-154.645 163.66v-66.984h53.202l-8.84 66.984zm-74.382 0-8.912-66.984h53.294v66.984zm-69.053 0h-.047c-3.656-.001-6.877-2.467-7.828-5.98l-16.442-61.004h54.193l8.912 66.984zm56.149-96.983-9.021-67.799 66.306.267v67.532zm87.286 0v-67.411l66.022.266-8.861 67.145zm-126.588-67.922 9.037 67.921h-58.287l-18.38-68.194zm237.635 164.905h-36.426l8.84-66.984h48.973l-14.137 61.217c-.784 3.396-3.765 5.767-7.25 5.767z"/>
					</svg>
				</div>}
		</div>
	)
}



// WEBPACK FOOTER //
// ./src/react/ui/features/Table.jsx